import { createTheme, type MantineColorsTuple } from '@mantine/core';

// Blue replaces the old purple (haist) — all color="haist" references now render blue
const haist: MantineColorsTuple = [
  '#EFF6FF',
  '#DBEAFE',
  '#BFDBFE',
  '#93C5FD',
  '#60A5FA',
  '#3B82F6',
  '#2563EB',
  '#1D4ED8',
  '#1E40AF',
  '#1E3A8A',
];

export const shopTheme = createTheme({
  fontFamily:
    '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',

  // Bigger overall — bumped ~1-2px above Mantine defaults (xs12/sm14/md16/lg18/xl20).
  fontSizes: {
    xs: '0.8125rem', // 13
    sm: '0.9375rem', // 15
    md: '1.0625rem', // 17
    lg: '1.1875rem', // 19
    xl: '1.375rem', // 22
  },

  colors: { haist },
  primaryColor: 'haist',
  primaryShade: 6,

  defaultRadius: 'sm',
  cursorType: 'pointer',

  components: {
    Button: {
      defaultProps: { radius: 'sm' },
    },
    TextInput: {
      defaultProps: { radius: 'sm' },
    },
    PasswordInput: {
      defaultProps: { radius: 'sm' },
    },
    Loader: {
      defaultProps: { type: 'dots' },
    },
    Modal: {
      styles: {
        title: { color: '#F4F4F5', fontWeight: 700 },
      },
    },
  },
});
